module.exports = __webpack_public_path__ + "img/icon-plus.2ffef9c9.svg";